import { Component, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pz-time-range',
    templateUrl: './time-range.component.html',
    styleUrls: ['./time-range.component.scss'],
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: TimeRangeComponent, multi: true}]
})

export class TimeRangeComponent implements OnChanges, ControlValueAccessor {
    public _startTime: Date | null = null;
    public _endTime: Date | null = null;

    private _onChange: (value: Date[] | null) => void;
    private _onTouched: () => void;

    set startTime(value: Date) {
        this._startTime = value;
        if (this._startTime && this._endTime) {
            this._onChange([this._startTime, this._endTime]);
        }
    }

    get startTime(): Date {
        return this._startTime;
    }

    set endTime(value: Date) {
        this._endTime = value;
        if (this._startTime && this._endTime) {
            this._onChange([this._startTime, this._endTime]);
        }
    }

    get endTime(): Date {
        return this._endTime;
    }

    writeValue(val): void {
        if (Array.isArray(val)) {
            this._startTime = val[0];
            this._endTime = val[1];
        }
        if (val === null) {
            this._startTime = undefined;
            this._endTime = undefined;
        }
    }

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    ngOnChanges(changes): void {
    }

    disabledHours = (): number[] => {
        const nums: number[] = [];
        for (let i = 0; i < this.startTime.getHours(); i++) {
            nums.push(i);
        }
        return nums;
    }

    disabledMinutes = (hour: number): number[] => {
        if (hour === this.startTime.getHours()) {
            const min: number[] = [];
            for (let i = 0; i < this.startTime.getMinutes(); i++) {
                min.push(i);
            }
            return min;
        } else {
            return [];
        }
    }

    disabledSeconds = (hour: number, minute: number): number[] => {
        if (hour === this.startTime.getHours() &&
            minute === this.startTime.getMinutes()) {
            const sec: number[] = [];
            for (let i = 0; i < this.startTime.getSeconds(); i++) {
                sec.push(i);
            }
            return sec;
        } else {
            return [];
        }
    }
}
